import { createSlice } from '@reduxjs/toolkit';
import { FiledLienApiResponse } from '@dill/dill-shared';
import {
  createFiledLienExtraReducer,
  getFiledLienExtraReducer,
  getSupplierFiledLiensExtraReducer,
  updateFiledLienExtraReducer,
  deleteFiledLienExtraReducer,
} from '../reducers/filedLiensReducers';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface FiledLienInitialState {
  loadingList: string[];
  filedLiens: FiledLienApiResponse[];
  loadingErrorList: { [x: string]: string[] }[];
  selectedFiledLiens: FiledLienApiResponse[];
  selectedFiledLien: FiledLienApiResponse | null;
}

const initialState: FiledLienInitialState = {
  loadingList: [],
  filedLiens: [],
  loadingErrorList: [],
  selectedFiledLiens: [],
  selectedFiledLien: null,
};

export const filedLiensSlice = createSlice({
  name: 'filedLiens',
  initialState,
  reducers: {
    resetFiledLiensRootState: () => initialState,
    selectFiledLiens: (state, action: PayloadAction<any[]>) => {
      const ii = [...state.selectedFiledLiens.map((iu) => ({ ...iu }))];
      const filteredFiledLiens = ii.filter(
        (filedLiens) => !action.payload.map((yy: any) => yy.id).includes(filedLiens.id)
      );
      state.selectedFiledLiens = [...filteredFiledLiens, ...action.payload];
    },
    selectFiledLien: (state, action: PayloadAction<FiledLienApiResponse | null>) => {
      state.selectedFiledLien = action.payload;
    },
    unSelectFiledLiens: (state, action: PayloadAction<any[]>) => {
      const filteredFiledLiens = state.selectedFiledLiens.filter(
        (filedLiens) => !action.payload.map((yy: any) => yy.id).includes(filedLiens.id)
      );
      state.selectedFiledLiens = [...filteredFiledLiens];
    },

    resetFiledLiens: (state) => {
      state.selectedFiledLiens = [];
      state.selectedFiledLien = null;
    },
  },
  extraReducers(builder) {
    createFiledLienExtraReducer(builder);
    getSupplierFiledLiensExtraReducer(builder);
    getFiledLienExtraReducer(builder);
    updateFiledLienExtraReducer(builder);
    deleteFiledLienExtraReducer(builder);
  },
});

export const {
  resetFiledLiensRootState,
  selectFiledLiens,
  unSelectFiledLiens,
  resetFiledLiens,
  selectFiledLien,
} = filedLiensSlice.actions;
